import Drawer from "../Drawer";
import { COGS_TABLE_COLUMNS } from "../../consts/cogsCanonicalColumns";

export const CogsColumnsDrawer = ({
    marginFromSidebar,
    isOpen,
    onClose,
    visibleColumnIds,
    onToggleColumn,
    onResetColumns,
    onShowAllColumns,
}) => {
    return (
        <Drawer
            isOpen={isOpen}
            onClose={onClose}
            marginFromSidebar={marginFromSidebar}
            width="500px"
            headerContent={
                <div>
                    <h2 className="font-semibold text-lg tracking-[-0.02em] text-primary">Columns</h2>
                    <p className="text-sm mt-1 leading-6 text-gray-600">
                        Choose which COGS fields stay visible in the table so you can build the custom view you need.
                    </p>
                </div>
            }
        >
            <div className="flex flex-col min-h-0">
                <div className="flex items-center gap-2 border-b border-border px-5 py-4">
                    <button
                        type="button"
                        onClick={onResetColumns}
                        className="inline-flex items-center justify-center rounded-md border border-border bg-white px-4 py-2 text-sm font-medium text-primary shadow-xs transition hover:bg-gray-50"
                    >
                        Default
                    </button>
                    <button
                        type="button"
                        onClick={onShowAllColumns}
                        className="inline-flex items-center justify-center rounded-md border border-border bg-white px-4 py-2 text-sm font-medium text-primary shadow-xs transition hover:bg-gray-50"
                    >
                        Show All
                    </button>
                </div>
                <div className="space-y-3 overflow-y-auto px-5 py-4">
                    {COGS_TABLE_COLUMNS.map((column) => {
                        const checked = visibleColumnIds.includes(column.id);
                        const disableToggle = checked && visibleColumnIds.length === 1;

                        return (
                            <label
                                key={column.id}
                                className={`flex items-start gap-3 rounded-md border border-border bg-background px-3 py-3 transition ${
                                    disableToggle ? "opacity-70" : ""
                                }`}
                            >
                                <input
                                    type="checkbox"
                                    className="mt-0.5 h-4 w-4 rounded border-gray-300 accent-primary focus:ring-primary focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-70"
                                    checked={checked}
                                    disabled={disableToggle}
                                    onChange={() => onToggleColumn?.(column.id)}
                                />
                                <div className="space-y-1">
                                    <p className="text-sm font-medium text-foreground">{column.label}</p>
                                    <p className="text-xs text-muted-foreground">
                                        {column.defaultVisible === false
                                            ? "Optional field for custom analysis views."
                                            : "Included in the default finance operating view."}
                                    </p>
                                </div>
                            </label>
                        );
                    })}
                </div>
            </div>
        </Drawer>
    );
};
